// extracted by mini-css-extract-plugin
export default {"overflow":"device-unlink-modal_overflow__wvwYO"};